import {
  List,
  Datagrid,
  TextField,
  RichTextField,
  DeleteWithConfirmButton,
  Edit,
  TextInput,
  // RichTextInput,
  Create,
  Show,
  ImageField,
  ImageInput,
} from 'react-admin'

import { CustomRichTextInput, LangRelatedTabbedForm, LangRelatedTabbedShow } from '../components'

const formatImageUrls = (value) => {
  if (!Array.isArray(value)) {
    return value
  }

  return value.map((image) => {
    if (typeof image === 'string') {
      return { src: image, title: image }
    }
    return image
  })
}

// const parseImageUrls = (value) => {
//   if (!Array.isArray(value)) {
//     return value
//   }

//   return value.map((image) => {
//     if (image?.rawFile instanceof File) {
//       return image
//     }
//     return image?.src || image
//   })
// }

// <Edit title={<PostTitle />}>
// const PostTitle = () => {
//   const record = useRecordContext()
//   return <span>Post {record ? `'${record.title}'` : ''}</span>
// }

export const SectionList = ({ isEdit, isDelete }) => (
  <List filters={[]}>
    <Datagrid bulkActionButtons={false} rowClick={isEdit ? 'edit' : 'show'}>
      <TextField source="title" />
      <RichTextField source="description" />
      {isDelete && (
        <DeleteWithConfirmButton confirmContent="This action could not be reverted. Are you sure?" />
      )}
    </Datagrid>
  </List>
)

export const SectionEdit = () => (
  <Edit>
    <LangRelatedTabbedForm
      generalFields={[
        // <CustomRichTextInput key="description" source="description" />,
        <TextInput key="description" source="description" fullWidth multiline rows={4} />,
        <ImageInput
          key="image"
          source="imageUrls"
          accept="image/*"
          multiple={true}
          format={formatImageUrls}
        >
          <ImageField source="src" title="title" />
        </ImageInput>,
      ]}
      tabFields={(lang) => [
        <CustomRichTextInput
          key={`content-${lang.id}`}
          source={`content.${lang.id}`}
          fullWidth
          multiline
          rows={4}
        />,
        <TextInput key={`videoUrl-${lang.id}`} source={`videoUrl.${lang.id}`} fullWidth />,
      ]}
    />
  </Edit>
)

export const SectionCreate = () => (
  <Create>
    <LangRelatedTabbedForm
      generalFields={[
        <TextInput key="title" source="title" />,
        // <CustomRichTextInput key="description" source="description" />,
        <TextInput key="description" source="description" fullWidth multiline rows={4} />,
        <ImageInput
          key="image"
          source="imageUrls"
          accept="image/*"
          multiple={true}
          format={formatImageUrls}
          // parse={parseImageUrls}
        >
          <ImageField source="src" title="title" />
        </ImageInput>,
      ]}
      tabFields={(lang) => [
        <CustomRichTextInput
          key={`content-${lang.id}`}
          source={`content.${lang.id}`}
          fullWidth
          multiline
          rows={4}
        />,
        <TextInput key={`videoUrl-${lang.id}`} source={`videoUrl.${lang.id}`} fullWidth />,
      ]}
    />
  </Create>
)

export const SectionShow = () => (
  <Show>
    <LangRelatedTabbedShow
      generalFields={[
        <TextField key="title" source="title" />,
        <RichTextField key="description" source="description" />,
      ]}
      tabFields={(lang) => [
        <RichTextField key={`content-${lang.id}`} source={`content.${lang.id}`} />,
        <TextField key={`videoUrl-${lang.id}`} source={`videoUrl.${lang.id}`} />,
      ]}
    />
  </Show>
)
